module.exports = __webpack_public_path__ + "img/jne_snb.1940dd80.svg";